import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import './MouseOverGuide.scss';

const propTypes = {
  children: PropTypes.node,
  icon: PropTypes.element,
  title: PropTypes.string,
};

const defaultProps = {
  children: <span />,
  icon: <FontAwesomeIcon icon={faQuestionCircle} />,
  title: '',
};

function MouseOverGuide({ children, icon, title }) {
  return (
    <div className="MouseOverGuide">
      <button className="MouseOverGuide__icon-button" type="button">
        {icon}
      </button>
      <div className="MouseOverGuide__card">
        <div className="MouseOverGuide__inner-card">
          <p className="MouseOverGuide__title">
            <b>{title}</b>
          </p>
          <p className="MouseOverGuide__content">{children}</p>
        </div>
      </div>
    </div>
  );
}

MouseOverGuide.propTypes = propTypes;
MouseOverGuide.defaultProps = defaultProps;

export default MouseOverGuide;
